import React, { Component } from "react";
import { AxiosResponse } from "axios";
import { Question, Topic } from "../../../../stores/CoursePreviewStore/Types";
import { getRequest } from "../../../../utils/httpRequest";

interface Props {
  topic: Topic;
  courseSlug: string;
  hidden?: boolean;
  position: number;
}

interface State {
  questions: Question[];
}

class Chapter extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      questions: props.topic.questions || [],
    };
  }

  componentDidMount() {
    const { courseSlug, topic } = this.props;

    if (!courseSlug || !topic?.id) return null;

    return getRequest(
      `/api/courses/${courseSlug}/topics/${topic.id}/questions.json`,
    ).then((response: AxiosResponse) => {
      this.setState({ questions: response.data });
    });
  }

  render() {
    const { hidden, position, topic } = this.props;
    const { questions } = this.state;
    const lessonCount = questions.length || (topic.questions || []).length;
    const lessonLabel = `${lessonCount || "View"} ${
      lessonCount === 1 ? "lesson" : "lessons"
    }`;
    const chapterNumber = position.toString().padStart(2, "0");

    const renderQuestions = () => {
      return questions.map((question) => (
        <li key={question.id || question.rank}>{question.name}</li>
      ));
    };

    return (
      <details className={`chap-item${hidden ? " chap-hidden" : ""}`}>
        <summary>
          <span className="num">{chapterNumber}</span>
          <span className="title">{topic.name}</span>
          <span className="summary-meta">{lessonLabel}</span>
        </summary>
        <div className="body">
          {topic.description && <p>{topic.description}</p>}
          {questions.length > 0 && <ol>{renderQuestions()}</ol>}
        </div>
      </details>
    );
  }
}

export default Chapter;
